import axiosService from 'axios';
import jsGlobalConfig from '../getJsGlobalConfig';

let instance;

/**
 * These endpoints has the correct csrf tokens and
 * uses the Content-Type = 'application/json' as default
 */
class PacksterAxiosInstance {

  #service = axiosService.create({
    headers: PacksterAxiosInstance.header(),
  });

  static header() {
    const header = jsGlobalConfig().getCsrfTokenHeader();
    header['Content-Type'] = 'application/json';
    return {
      ...header,
      'igepa-ajax': true,
      'referrerPolicy': 'origin',
    }
  }

  get axios() {
    return this.#service;
  }

}

function axiosInstance() {
  if (instance) {
    return instance;
  } else {
    instance = new PacksterAxiosInstance();
    instance.axios.interceptors.response.use(response => {
      return response;
    }, err => {
      if (err.response.status === 403) {
        let url = err.request.responseURL;

        if (url.indexOf('/checkout/') !== -1) {
          window.location.href = '/checkout/login/?error=1&timeout=1&accessDenied=true';
        } else if (url.indexOf('/account/') !== -1) {
          window.location.href = '/login/?error=1&timeout=1&accessDenied=true';
        } else {
          window.location.reload();
        }
      }
      return Promise.reject(err);
    });
    return instance;
  }
}


export default axiosInstance;
